export default __webpack_public_path__ + "static/media/583.b1e6c07d.png";